import React from 'react';
import { connect } from 'react-redux';
import Scroll from 'react-scroll';
import scrollToComponent from 'react-scroll-to-component';
import { Container, Row, Col, ScreenClassRender } from 'react-grid-system';
import { getLocalizedText } from '@vp-dst/localization-util';
import socialMediaProducts from 'data/socialMediaProducts.json';

import {
  fireBriefPageHit,
  fireProductDropdownSelectedInitialProduct,
  fireProductDropdownChangedProduct,
  fireProductDropdownUnSelectedProduct,
  fireStandardDifyCheckoutCTAClicked,
  fireStandardDifySaveCTAClicked,
  firePickYourTimeCTAClicked,
  fireProductConfigurationListShown,
  fireProductConfigurationListRemovedProductConfiguration,
  fireYesCoDesignRadioClicked,
  fireNoCoDesignRadioClicked,
  fireBriefCustomerTooltipExpanded,
} from 'utils/Tracking';


import {
  setSelectedProduct,
  setNewMultiselectedProducts,
  setSelectedProductError,
  setSelectedProductConfigurations,
  removeSelectedProductConfiguration,
  setNote,
  setNoteError,
  setNoteErrorsSuppressed,
  setSize,
  setSizeError,
  setSizeErrorsSuppressed,
  setSocialMediaLink,
  setDocumentPagePreviewModalVisible,
  setDocumentPagePreviewModalDocumentPage,
  setCoDesignSelected,
} from 'redux/actionCreators';
import { submitDifyOrder, submitHolidayUGOrder, saveDifyOrder } from 'redux/thunkActionCreators';
import { defaultTextStyle, colors } from 'settings/theme';
import DifyOrderDTO from 'services/designServices/dtos/DifyOrderDTO';
import DifyOrderUpdateDTO from 'services/designServices/dtos/DifyOrderUpdateDTO';
import DSBriefModel from 'models/DSBriefModel';
import QueryStringUtil from 'utils/QueryStringUtil';
import {GetProductInformationFromCimdoc} from 'services/CimdocRenderingService';

import ProductSelector from 'components/ProductSelector';
import DropdownMultiProductSelector from 'components/DropdownMultiProductSelector';
import SocialMediaInfoPanel from 'components/SocialMediaInfoPanel';
import BriefDetail, {requiresSizeField} from 'components/BriefDetail';
import Price from 'components/vistaprintUILibrary/Price';
import Button from 'components/vistaprintUILibrary/Button';
import LoadingBox from 'components/vistaprintUILibrary/LoadingBox';
import DocumentPageThumbnail from 'components/vistaprintUILibrary/DocumentPageThumbnail';
import Modal from 'components/vistaprintUILibrary/Modal';
import Loader from 'components/vistaprintUILibrary/Loader';
import RadioButton from 'components/vistaprintUILibrary/RadioButton';
import ErrorMessage from 'components/vistaprintUILibrary/ErrorMessage';

var scroll = Scroll.animateScroll;

class ProductPage extends React.Component {
  constructor(props) {
    super(props);

    this.productSectionRef = React.createRef();
    this.noteSectionRef = React.createRef();

    this.noteOnChange = this.noteOnChange.bind(this);
    this.noteOnBlur = this.noteOnBlur.bind(this);
    this.sizeOnChange = this.sizeOnChange.bind(this);
    this.socialMediaLinkOnChange = this.socialMediaLinkOnChange.bind(this);
    this.sizeOnBlur = this.sizeOnBlur.bind(this);
    this.selectedProductOnChange = this.selectedProductOnChange.bind(this);
    this.multiSelectedProductOnChange = this.multiSelectedProductOnChange.bind(this);
    this.removeProductConfigurationOnClick = this.removeProductConfigurationOnClick.bind(this);
    this.documentPagePreviewOnClick = this.documentPagePreviewOnClick.bind(this);
    this.documentPagePreviewModalOnClose = this.documentPagePreviewModalOnClose.bind(this);
    this.coDesignYesOnClick = this.coDesignYesOnClick.bind(this);
    this.coDesignNoOnClick = this.coDesignNoOnClick.bind(this);
    this.checkoutOnClick = this.checkoutOnClick.bind(this);
    this.saveOnClick = this.saveOnClick.bind(this);
    this.uploadGoSubmitClick = this.uploadGoSubmitClick.bind(this);
    this.scheduleCoDesignOnClick = this.scheduleCoDesignOnClick.bind(this);
    this.isBriefComplete = this.isBriefComplete.bind(this);
    this.tooltipExpanderOnClick = this.tooltipExpanderOnClick.bind(this);
    this.productInfoResolved = this.productInfoResolved.bind(this);

    this.state = {};
  }

  productInfoResolved(result) {
    this.setState({
        ...this.state, 
        previewsForProvidedCimdoc: result.previewUrls, 
        productsFromProvidedCimdoc: result.productsFromProvidedCimdoc
      });
  }

  componentDidMount() {
    setTimeout(fireBriefPageHit, 1000);

    if (window.startMouseFlow) {
      window.startMouseFlow();
    }

    scroll.scrollTo(0, {
      duration: 50
    });

    // if we have an alt doc id, populate the product, but overwrite the priceMultiplier and priceHTML such that the price is $5.00
    if (DSBriefModel.altDocId) {
      this.props.setSelectedProduct({
        ...DSBriefModel.preSelectedProduct,
        priceMultiplier: 1,
        priceHTML: DSBriefModel.localizedBasePriceHTML,
      });
    } else if (DSBriefModel.preSelectedProduct) {
      this.props.setSelectedProduct(DSBriefModel.preSelectedProduct);
    }

    if (DSBriefModel.preSelectedProductConfig.length > 0) {
      fireProductConfigurationListShown();
      this.props.setSelectedProductConfigurations(DSBriefModel.preSelectedProductConfig, DSBriefModel.preSelectedProductPfid);
    }
    
    const socialMediaDocumentId = QueryStringUtil.getValueByKey("smdDoc") || this.props.socialMediaTemplateDocId;
    if(socialMediaDocumentId)
    {
      GetProductInformationFromCimdoc(socialMediaDocumentId)
        .then(this.productInfoResolved);
    }
  }

  selectedProductOnChange(selectedProduct) {
    const {
      selectedProduct: prevSelectedProduct,
      setSelectedProduct,
    } = this.props;

    if (prevSelectedProduct === null && selectedProduct !== null) {
      fireProductDropdownSelectedInitialProduct(selectedProduct.pfid);
    } else {
      if (selectedProduct !== null) {
        fireProductDropdownChangedProduct(selectedProduct.pfid);
      } else {
        fireProductDropdownUnSelectedProduct();
      }
    }

    setSelectedProduct(selectedProduct);
  }
  
  multiSelectedProductOnChange(newMultiselectedProducts) {
    const {
      setNewMultiselectedProducts,
    } = this.props;

    setNewMultiselectedProducts(newMultiselectedProducts);
  }

  removeProductConfigurationOnClick(selectedProductConfigurationId) {
    const {
      selectedProduct,
      removeSelectedProductConfiguration,
    } = this.props;

    fireProductConfigurationListRemovedProductConfiguration();

    removeSelectedProductConfiguration(selectedProductConfigurationId, selectedProduct.pfid);
  }

  tooltipExpanderOnClick() {
    fireBriefCustomerTooltipExpanded();
  }

  noteOnChange(event) {
    const {
      note: prevNote,
      noteError: prevNoteError,
      setNote,
      setNoteError,
    } = this.props;

    const note = event.target.value;

    if (note !== prevNote) {
      setNote(note);
    }

    let noteError = null;
    if (note === '') {
      noteError = getLocalizedText('please-describe-your-design-idea');
    }

    if (noteError !== prevNoteError) {
      setNoteError(noteError);
    }
  }

  socialMediaLinkOnChange(event) {
    const {
      link: prevLink,
      setSocialMediaLink
    } = this.props;

    const link = event.target.value;

    if (link !== prevLink) {
      setSocialMediaLink(link);
    }
  }

  
  sizeOnChange(event) {
    const {
      size: prevSize,
      sizeError: prevSizeError,
      setSize,
      setSizeError,
    } = this.props;

    const size = event.target.value;

    if (size !== prevSize) {
      setSize(size);
    }

    let sizeError = null;
    if (size === '') {
      sizeError = getLocalizedText('please-describe-your-design-idea');//TODO:  Add better error message
    }

    if (sizeError !== prevSizeError) {
      setSizeError(sizeError);
    }
  }

  // input validation errors are suppressed until the first blur event
  noteOnBlur() {
    const {
      noteErrorsSuppressed,
      setNoteErrorsSuppressed,
    } = this.props;

    if (noteErrorsSuppressed) {
      setNoteErrorsSuppressed(false);
    }
  }

  // input validation errors are suppressed until the first blur event
  sizeOnBlur() {
    const {
      sizeErrorsSuppressed,
      setSizeErrorsSuppressed,
    } = this.props;

    if (sizeErrorsSuppressed) {
      setSizeErrorsSuppressed(false);
    }
  }

  coDesignYesOnClick() {
    fireYesCoDesignRadioClicked();

    this.props.setCoDesignSelected(true);
  }

  coDesignNoOnClick() {
    fireNoCoDesignRadioClicked();

    this.props.setCoDesignSelected(false);
  }

  documentPagePreviewOnClick({ altDocId, pageNumber, templateId }) {
    const {
      setDocumentPagePreviewModalVisible,
      setDocumentPagePreviewModalDocumentPage,
    } = this.props;

    setDocumentPagePreviewModalDocumentPage({ altDocId, pageNumber, templateId });
    setDocumentPagePreviewModalVisible(true);
  }

  documentPagePreviewModalOnClose() {
    const {
      setDocumentPagePreviewModalVisible,
    } = this.props;

    setDocumentPagePreviewModalVisible(false);
  }

  uploadGoSubmitClick() {

    const {
      altDocId,
      note,
      uploads,
      noteError,
      noteErrorsSuppressed,
      submitHolidayUGOrder,
      setNoteError,
      setNoteErrorsSuppressed,
    } = this.props;

    if (note.length === 0) {
      if (noteErrorsSuppressed) {
        setNoteErrorsSuppressed(false);
      }

      if (!noteError) {
        setNoteError(getLocalizedText('please-describe-your-design-idea'));
      }

      scrollToComponent(this.noteSectionRef.current);
      return;
    }

    var templates = DSBriefModel.templates;

    submitHolidayUGOrder({
      uploadIds: { ...uploads },
      templateId: templates[0],
      documentId: altDocId,
      note
    });
  }

  checkoutOnClick() {
    const {
      selectedProduct,
      multiselectedProducts,
      selectedProductConfigurations,
      note,
      uploads,
      uploadRefs,
      noteError,
      noteErrorsSuppressed,
      submitDifyOrder,
      setSelectedProductError,
      setNoteError,
      setNoteErrorsSuppressed,
      size,
      sizeError,
      sizeErrorsSuppressed,
      setSizeError,
      setSizeErrorsSuppressed,
      socialMediaLink
    } = this.props;

    if (window.tagMouseFlow) {
      window.tagMouseFlow('DifyAddToCart');
    }

    if (!selectedProduct || (selectedProduct.pfid === "DST-SMD" && ((multiselectedProducts.length === 0 || multiselectedProducts.indexOf("noSelection") !== -1) && !this.state.productsFromProvidedCimdoc) )) {
      setSelectedProductError(getLocalizedText('please-select-a-product'));
      scrollToComponent(this.productSectionRef.current);
      return;
    }

    if(multiselectedProducts.length > 3)
    {
      setSelectedProductError(getLocalizedText('please-select-three-or-fewer-products'));
      scrollToComponent(this.productSectionRef.current);
      return;
    }

    if (note.length === 0) {
      if (noteErrorsSuppressed) {
        setNoteErrorsSuppressed(false);
      }

      if (!noteError) {
        setNoteError(getLocalizedText('please-describe-your-design-idea'));
      }

      scrollToComponent(this.noteSectionRef.current);
      return;
    }

    if ( requiresSizeField(selectedProduct.productGroup) && !DSBriefModel.isEditFromCart && size.length === 0) {
      if (sizeErrorsSuppressed) {
        setSizeErrorsSuppressed(false);
      }

      if (!sizeError) {
        setSizeError(getLocalizedText('please-describe-your-design-idea')); //TODO:  Better error messaging
      }

      scrollToComponent(this.noteSectionRef.current);
      return;
    }

    const concatanatedNoteWithSize = size.length !== 0 ? `${note}\n\n\n------------\nSize: ${size}` : note;
    
    const concatanatedNoteWithSocialMedia = socialMediaLink.length !== 0 ? `${concatanatedNoteWithSize}\n\n\n------------\nSocial Media Link(s): ${socialMediaLink}` : concatanatedNoteWithSize;

    const multiselectedProductObjectsToSend =  this.state.productsFromProvidedCimdoc ? 
      this.state.productsFromProvidedCimdoc.map(product => ({"type": product, "DocId": QueryStringUtil.getValueByKey("smdDoc")})) 
      : multiselectedProducts.map(product => ({"type": product}))

    const difyOrderDTO = new DifyOrderDTO({
      productName: selectedProduct.name,
      productPfid: selectedProduct.pfid,
      productConfigurations: selectedProductConfigurations,
      note: concatanatedNoteWithSocialMedia,
      uploads,
      uploadRefs,
      difyServiceQuantity: selectedProduct.priceMultiplier,
      multiselectedProducts: multiselectedProductObjectsToSend
    });

    const errorMessage = difyOrderDTO.validate();

    if (errorMessage) {
      this.setState({
        difyErrorMessage: errorMessage,
      });

      return;
    }

    fireStandardDifyCheckoutCTAClicked();

    submitDifyOrder(difyOrderDTO);
  }

  saveOnClick() {
    const {
      selectedProduct,
      selectedProductConfigurations,
      note,
      uploads,
      uploadRefs,
      noteError,
      noteErrorsSuppressed,
      saveDifyOrder,
      setNoteError,
      setNoteErrorsSuppressed,
    } = this.props;

    if (window.tagMouseFlow) {
      window.tagMouseFlow('DifySaveInCart');
    }

    if (note.length === 0) {
      if (noteErrorsSuppressed) {
        setNoteErrorsSuppressed(false);
      }

      if (!noteError) {
        setNoteError(getLocalizedText('please-describe-your-design-idea'));
      }

      scrollToComponent(this.noteSectionRef.current);
      return;
    }

    const difyOrderUpdateDTO = new DifyOrderUpdateDTO({
      productName: selectedProduct.name,
      productPfid: selectedProduct.pfid,
      productConfigurations: selectedProductConfigurations,
      note,
      uploads,
      uploadRefs,
      difyServiceQuantity: selectedProduct.priceMultiplier,
      itemId: DSBriefModel.merchantItemId
    });

    const errorMessage = difyOrderUpdateDTO.validate();

    if (errorMessage) {
      this.setState({
        difyErrorMessage: errorMessage,
      });

      return;
    }

    fireStandardDifySaveCTAClicked();

    saveDifyOrder(difyOrderUpdateDTO);
  }

  scheduleCoDesignOnClick() {
    const {
      selectedProduct,
      note,
      noteError,
      noteErrorsSuppressed,
      setSelectedProductError,
      setNoteError,
      setNoteErrorsSuppressed,
    } = this.props;

    if (!selectedProduct) {
      setSelectedProductError(getLocalizedText('please-select-a-product'));
      scrollToComponent(this.productSectionRef.current);
      return;
    }

    if (note.length === 0) {
      if (noteErrorsSuppressed) {
        setNoteErrorsSuppressed(false);
      }

      if (!noteError) {
        setNoteError(getLocalizedText('please-describe-your-design-idea'));
      }

      scrollToComponent(this.noteSectionRef.current);
      return;
    }

    firePickYourTimeCTAClicked();

    this.props.history.push('/schedule');

    if (window.tagMouseFlow && window.startMouseFlow) {
      window.tagMouseFlow('CoDesignSideChoosen');
    }
  }

  isBriefComplete() {
    const {
      selectedProduct,
      note,
      noteError,
    } = this.props;

    return (
      selectedProduct !== null &&
      note.length > 0 &&
      noteError === null
    );
  }

  render() {
    const {
      selectedProduct,
      multiselectedProducts,
      selectedProductError,
      selectedProductConfigurations,
      coDesignSelected,
      note,
      noteError,
      noteErrorsSuppressed,
      orderSubmitting,
      documentPagePreviewModalVisible,
      documentPagePreviewModalDocumentPage,
      uploads,
      uploadRefs,
      size,
      sizeError,
      sizeErrorsSuppressed,
    } = this.props;

    const altDocId = DSBriefModel.altDocId;
    const numPages = DSBriefModel.templatesNum;
    const templates = DSBriefModel.templates;
    
    const isSocialMediaDesign = QueryStringUtil.getValueByKey("smd") || (DSBriefModel.preSelectedProduct && DSBriefModel.preSelectedProduct.pfid === "DST-SMD");
    const hasSmdTemplateEditCimdoc = QueryStringUtil.getValueByKey("smdDoc") || this.props.socialMediaTemplateDocId;


    return (
      <ScreenClassRender
        render={screenClass => {
          const containerRightLeftPadding = {
            'xs': 20,
            'sm': 40,
            'md': 40,
            'lg': 40,
            'xl': 80,
          };

          const containerShadow = '0 4px 5px 0 rgba(0,0,0,0.15)';
          const containerBorderRadius = '10px';
          const containerPadding = `30px ${containerRightLeftPadding[screenClass]}px`;

          //SMD-TODO:  This is some hardcoded nonsense to support the fact that the french social media promotion email went out with an incorrect product name.  We should clean this up once we're pretty sure
          //no one will be clicking that link anymore.
          let fakeFrenchPreselectedSocialMediaProduct = {};
          Object.assign(fakeFrenchPreselectedSocialMediaProduct, DSBriefModel.preSelectedProduct);
          if(fakeFrenchPreselectedSocialMediaProduct)
          {
            fakeFrenchPreselectedSocialMediaProduct.name = "Visuels Pour Réseaux Sociaux";
          }
          const shouldUseFakeFrenchPreselectedProduct = (DSBriefModel.preSelectedProduct && DSBriefModel.preSelectedProduct.name === "SocialMediaDesign" && window.location.origin.split('.').pop().toLowerCase() === "fr"); //Trying to specifically target people who got the french social media email, and No One Else

          return (
            <Container fluid xs sm md>
              { /* if we have an alt-doc-id or a template, we don't need to ask for which product */}
              {!(templates || DSBriefModel.altDocId) &&
                <Row>
                  <Col xs={12}>
                    <div
                      ref={this.productSectionRef}
                      style={{
                        width: '100%',
                        borderRadius: containerBorderRadius,
                        paddingTop: 20,
                        paddingBottom: 20,
                        marginBottom: 40,

                        background: `linear-gradient(132deg, ${colors.blueMid}, ${colors.blueDark})`,
                        boxShadow: containerShadow,

                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          ...defaultTextStyle,
                          color: 'white',
                          fontSize: '2em',
                          fontWeight: 'bold',
                          textAlign: 'center',

                          marginBottom: 15,
                        }}
                      >
                        {getLocalizedText('hi-what-do-you-need-designed')}

                      </div>

                      {isSocialMediaDesign && !hasSmdTemplateEditCimdoc &&
                      <div>
                        <SocialMediaInfoPanel/>
                    
                        <DropdownMultiProductSelector
                            productGroups={socialMediaProducts}
                            setMultiselectedProducts={this.multiSelectedProductOnChange}
                            multiselectedProducts={multiselectedProducts}
                            preSelectedProduct={DSBriefModel.preSelectedProduct}
                            error={selectedProductError}
                            isReadOnly={DSBriefModel.isEditFromCart || (isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled)}
                            key="multiselector"
                        />
                      </div>
                    }

                    {!(isSocialMediaDesign && !hasSmdTemplateEditCimdoc) &&
                      <ProductSelector
                        productGroups={DSBriefModel.productsByCategory}
                        selectedProductOnChange={this.selectedProductOnChange}
                        selectedProduct={selectedProduct}
                        preSelectedProduct={shouldUseFakeFrenchPreselectedProduct ? fakeFrenchPreselectedSocialMediaProduct : DSBriefModel.preSelectedProduct}  //SMD-TODO:  When the above hardcoded fake preselected product stuff is cleaned up, this needs to just be preSelectedProduct={DSBriefModel.preSelectedProduct}
                        error={selectedProductError}
                        disabled={DSBriefModel.isEditFromCart || isSocialMediaDesign}
                      />
                    }

                      {!DSBriefModel.isEditFromCart &&
                        <div style={{
                              ...defaultTextStyle,
                              fontSize: '1.8em',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              color: 'white',
                            }}>
                          {!selectedProduct&&
                              <span>{getLocalizedText('starting-at')}</span>
                          }
                          <span>
                              <Price
                                priceHTML={selectedProduct ? selectedProduct.priceHTML : DSBriefModel.localizedBasePriceHTML}
                                style ={{display: 'inline'}}
                              />
                          </span>
                        </div>
                      }
                    </div>
                  </Col>
                </Row>
              }
              <Row>
                <Col
                  xs={12}
                  style={{
                    overflow: 'visible', // allow shadow to spread beyond this container
                    marginBottom: 40,
                  }}
                >
                  <div
                    ref={this.noteSectionRef}
                    style={{
                      boxShadow: containerShadow,
                      borderRadius: containerBorderRadius,
                      padding: containerPadding,
                      backgroundColor: 'white',
                    }}
                  >
                    
                    {isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled && 
                      <ErrorMessage text={getLocalizedText("not-taking-social-media-orders")} />
                    }

                    {hasSmdTemplateEditCimdoc && this.state.previewsForProvidedCimdoc &&
                      <div style={{textAlign:"center"}}>
                        { this.state.previewsForProvidedCimdoc.map(url => <img src={url} style={{margin:10}} alt="" />) }
                      </div>
                    }

                    <BriefDetail
                      altDocId={altDocId}
                      numPages={numPages}
                      note={note}
                      noteOnChange={this.noteOnChange}
                      noteErrorMessage={noteErrorsSuppressed ? null : noteError}
                      documentPagePreviewOnClick={this.documentPagePreviewOnClick}
                      selectedProductConfigurations={selectedProductConfigurations}
                      removeProductConfigurationOnClick={this.removeProductConfigurationOnClick}
                      isReadOnly={isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled}
                      isHolidayUG={DSBriefModel.isHolidayUG}
                      uploads={uploads}
                      uploadRefs={uploadRefs}
                      templates={templates}
                      size = {size}
                      sizeOnChange = {this.sizeOnChange}
                      socialMediaLinkOnChange = {this.socialMediaLinkOnChange}
                      sizeErrorMessage = {sizeErrorsSuppressed ? null : sizeError}
                      selectedProduct = {selectedProduct}
                      isEditFromCart = {DSBriefModel.isEditFromCart}
                      tooltipExpanderOnClick={this.tooltipExpanderOnClick}
                      isSocialMediaDesign = {isSocialMediaDesign}
                      preSelectedProductName = {DSBriefModel.preSelectedProductName}
                    />

                    {!DSBriefModel.isEditFromCart && DSBriefModel.designLivePreSelected && //if CoDesign is pre-selected show "pick-your-time" button
                      <div
                        style={{
                          marginTop: 40,
                          textAlign: 'center',
                        }}
                      >
                        
                        {isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled && 
                          <ErrorMessage text={getLocalizedText("not-taking-social-media-orders")} />
                        }
                        
                        <Button
                          style={{
                            width: '100%',
                            maxWidth: 400,
                          }}
                          type="primary"
                          text={getLocalizedText("pick-your-time")}
                          large={true}
                          onClick={this.scheduleCoDesignOnClick}
                          disabled={orderSubmitting || (isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled)}
                        />
                      </div>
                    }

                    {!DSBriefModel.coDesignIsEnabled &&  // if CoDesign isn't enabled, show the checkout button here
                      <div
                        style={{
                          marginTop: 40,
                          borderTop: `1px solid ${colors.border}`,
                          textAlign: 'center',
                        }}
                      >
                        <div
                          style={{
                            marginTop: 40,
                            marginBottom: 10,
                            ...defaultTextStyle,
                            fontSize: '1.5em',
                          }}
                        >
                          <span>{getLocalizedText('receive-a-design-ready-for-review-1')}</span>                          
                          <span style={{ fontWeight: 'bold', marginLeft: 4 }}>{getLocalizedText('receive-a-design-ready-for-review-2')}</span>
                          <span dangerouslySetInnerHTML={{ __html:getLocalizedText('disclaimer')}}/>
                        </div>
                        <div>
                          {!DSBriefModel.isEditFromCart && 
                            <Price
                              priceHTML={DSBriefModel.priceHTML}
                              style={{
                                ...defaultTextStyle,
                                fontSize: '2em',
                                fontWeight: 'bold',
                                marginBottom: 20,
                              }}
                            />
                          }
                        </div>
                        
                      {isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled && 
                        <ErrorMessage text={getLocalizedText("not-taking-social-media-orders")} />
                      }
                      {!DSBriefModel.isEditFromCart && 
                      <Button
                          style={{
                            width: '100%',
                            maxWidth: 400,
                          }}
                          type="primary"
                          text={DSBriefModel.isHolidayUG ? getLocalizedText("submit") : getLocalizedText('checkout')}
                          large={true}
                          onClick={DSBriefModel.isHolidayUG? this.uploadGoSubmitClick : this.checkoutOnClick}
                          disabled={orderSubmitting  || (isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled) || (hasSmdTemplateEditCimdoc && !this.state.productsFromProvidedCimdoc)}
                        />}
                        {DSBriefModel.isEditFromCart && DSBriefModel.isCoDesign &&
                          <div
                            style={{
                              marginTop: 40,
                              marginBottom: 10,
                              ...defaultTextStyle,
                              fontSize: '1.5em',
                            }}
                          >
                            <span>{getLocalizedText('if-you-would-like-to-change-appointment-time')}</span>
                          </div>  
                        }
                        {DSBriefModel.isEditFromCart && <Button
                          style={{
                            width: '100%',
                            maxWidth: 400,
                          }}
                          type="primary"
                          text={getLocalizedText('save')}
                          large={true}
                          onClick={this.saveOnClick}
                          disabled={orderSubmitting  || (isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled)}
                        />
                        }
                      </div>
                    }
                    
                  </div>
                </Col>
              </Row>
              {DSBriefModel.coDesignIsEnabled && // if CoDesign is enabled 
                !DSBriefModel.designLivePreSelected && //and CoDesign is not preSelected based on Hub Selection
                <Row>
                  <Col
                    xs={12}
                    style={{
                      overflow: 'visible',
                    }}
                  >
                    <div
                      style={{
                        boxShadow: containerShadow,
                        borderRadius: containerBorderRadius,
                        padding: containerPadding,
                        backgroundColor: 'white',
                      }}
                    >
                      <div>
                        <Row>
                          <Col xs={12}>
                            <div
                              style={{
                                ...defaultTextStyle,
                                fontSize: '2em',
                                fontWeight: 'bold',
                                textAlign: 'center',

                                marginBottom: 30,
                              }}
                            >
                              {getLocalizedText('would-you-like-to-review-in-real-time')}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <RadioButton
                              disabled={DSBriefModel.isEditFromCart}
                              style={{
                                marginBottom: 20,
                              }}
                              radioButtonAlignment="top"
                              label={(
                                <div
                                  style={{
                                    ...defaultTextStyle,
                                    fontSize: '1.3em',
                                  }}
                                >
                                  <div
                                    style={{
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        marginLeft: 4,
                                      }}
                                    >
                                      {getLocalizedText('yes')}
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      {getLocalizedText('lets-schedule-time')}
                                  </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: '0.8em',
                                    }}
                                  >
                                    <span>{getLocalizedText('talk-directly-with-the-designer')}</span>
                                    <span style={{ marginLeft: 5, fontStyle: 'italic' }}>{getLocalizedText('no-additional-fee')}</span>
                                  </div>
                                </div>
                              )}
                              value="co-design"
                              selected={coDesignSelected}
                              onClick={this.coDesignYesOnClick}
                            />

                            <RadioButton
                              disabled={DSBriefModel.isEditFromCart}
                              style={{
                                marginBottom: 40,
                              }}
                              radioButtonAlignment="top"
                              label={(
                                <div
                                  style={{
                                    ...defaultTextStyle,
                                    fontSize: '1.3em',
                                  }}
                                >
                                  <div
                                    style={{
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        marginLeft: 4,
                                      }}
                                    >
                                      {getLocalizedText('no-thanks')}
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      {getLocalizedText('i-prefer-to-review')}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: '0.8em',
                                    }}
                                  >
                                    <span>{getLocalizedText('provide-written-feedback')}</span>
                                  </div>
                                </div>
                              )}
                              value="dify"
                              selected={!coDesignSelected}
                              onClick={this.coDesignNoOnClick}
                            />
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              {isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled && 
                                <ErrorMessage text={getLocalizedText("not-taking-social-media-orders")} />
                              }
                              <Button
                                style={{
                                  width: '100%',
                                  maxWidth: 400,
                                }}
                                type="primary"
                                text={coDesignSelected ? getLocalizedText("pick-your-time") : getLocalizedText("checkout")}
                                large={true}
                                onClick={coDesignSelected ? this.scheduleCoDesignOnClick : this.checkoutOnClick}
                                disabled={orderSubmitting  || (isSocialMediaDesign && !DSBriefModel.socialMediaDesignEnabled)  || (hasSmdTemplateEditCimdoc && !this.state.productsFromProvidedCimdoc)}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              }
              <LoadingBox
                show={orderSubmitting}
                text={getLocalizedText('submitting-order')}
              />
              <Modal
                open={documentPagePreviewModalVisible}
                buttons={
                  <Button
                    type="secondary"
                    text={getLocalizedText('close')}
                    onClick={this.documentPagePreviewModalOnClose}
                  />
                }
                onClose={this.documentPagePreviewModalOnClose}
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 20,
                  }}
                >
                  {documentPagePreviewModalDocumentPage === null &&
                    <Loader text={getLocalizedText('loading-preview')} />
                  }
                  {documentPagePreviewModalDocumentPage !== null &&
                    <DocumentPageThumbnail
                      altDocId={documentPagePreviewModalDocumentPage.altDocId}
                      pageNumber={documentPagePreviewModalDocumentPage.pageNumber}
                      templateId={documentPagePreviewModalDocumentPage.templateId}
                      height="calc(100% - 60px)" // 100% of the container - 60px for the close button
                      width="100%"
                      maxHeight="calc(60vh - 60px - 95px)" // height of the modal - 60px for the close button - 95px for the modal heading and padding
                      maxWidth="100%"
                      imageWidthPixels={400}
                      imageHeightPixels={400}
                      shadow={false}
                      showBorder={true}
                      zoomable={true}
                      zoomFactor={2}
                    />
                  }
                </div>
              </Modal>
            </Container>
          );
        }}
      />
    );
  }
};

const mapStateToProps = state => {
  return {
    selectedProduct: state.selectedProduct,
    multiselectedProducts: state.multiselectedProducts,
    selectedProductError: state.selectedProductError,
    selectedProductConfigurations: state.selectedProduct ? (state.selectedProductConfigurationsMap.get(state.selectedProduct.pfid) || []) : [],
    coDesignSelected: state.coDesignSelected,
    note: state.note,
    noteError: state.noteError,
    noteErrorsSuppressed: state.noteErrorsSuppressed,
    size: state.size,
    socialMediaLink: state.socialMediaLink,
    sizeError: state.sizeError,
    sizeErrorsSuppressed: state.sizeErrorsSuppressed,
    uploads: state.uploads,
    uploadRefs: state.uploadRefs,
    orderSubmitting: state.orderSubmitting,
    documentPagePreviewModalVisible: state.documentPagePreviewModalVisible,
    documentPagePreviewModalDocumentPage: state.documentPagePreviewModalDocumentPage,
    socialMediaTemplateDocId: state.socialMediaTemplateDocId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSelectedProduct: selectedProduct => dispatch(setSelectedProduct(selectedProduct)),
    setNewMultiselectedProducts: multiselectedProducts => dispatch(setNewMultiselectedProducts(multiselectedProducts)),
    setSelectedProductError: selectedProductError => dispatch(setSelectedProductError(selectedProductError)),
    setSelectedProductConfigurations: (selectedProductConfigurations, pfid) => dispatch(setSelectedProductConfigurations(selectedProductConfigurations, pfid)),
    setCoDesignSelected: coDesignSelected => dispatch(setCoDesignSelected(coDesignSelected)),
    removeSelectedProductConfiguration: (selectedProductConfigurationId, pfid) => dispatch(removeSelectedProductConfiguration(selectedProductConfigurationId, pfid)),
    setNote: note => dispatch(setNote(note)),
    setNoteError: noteError => dispatch(setNoteError(noteError)),
    setNoteErrorsSuppressed: noteErrorsSuppressed => dispatch(setNoteErrorsSuppressed(noteErrorsSuppressed)),
    setSize: size => dispatch(setSize(size)),
    setSocialMediaLink: socialMediaLink => dispatch(setSocialMediaLink(socialMediaLink)),
    setSizeError: sizeError => dispatch(setSizeError(sizeError)),
    setSizeErrorsSuppressed: sizeErrorsSuppressed => dispatch(setSizeErrorsSuppressed(sizeErrorsSuppressed)),
    submitDifyOrder: difyOrderDTO => dispatch(submitDifyOrder(difyOrderDTO)),
    saveDifyOrder: difyOrderUpdateDTO => dispatch(saveDifyOrder(difyOrderUpdateDTO)),
    submitHolidayUGOrder: request => dispatch(submitHolidayUGOrder(request)),
    setDocumentPagePreviewModalVisible: documentPagePreviewModalVisible => dispatch(setDocumentPagePreviewModalVisible(documentPagePreviewModalVisible)),
    setDocumentPagePreviewModalDocumentPage: documentPagePreviewModalDocumentPage => dispatch(setDocumentPagePreviewModalDocumentPage(documentPagePreviewModalDocumentPage)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);



// WEBPACK FOOTER //
// ./src/pages/ProductPage.js